import { ValidationMessages } from "@/types/functions";

const validationDE: ValidationMessages = {
    'min_length': '{field} muss mindestens 0:{min} Elemente ausgewählt haben',
    'max_length': '{field} darf maximal 0:{max} Elemente ausgewählt haben',
    'multiple': 'Die {field} muss ein vielfaches von 0:{multiple} sein'
}

export default validationDE
